import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const InspectionTypeSchedule = () => {
  return (
    <SettingsMetaData propertyName={"Inspection_Type_Schedule"} viewPropertyName={"Inspection Type"} />
  );
};
export default InspectionTypeSchedule;